import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-two',
  templateUrl: './listing-two.component.html',
  styleUrls: ['./listing-two.component.scss']
})
export class ListingTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
